
export const bjornsholmReportVersion = 1;